export const ATTENDANCE_POLICY_STATS = 'ATTENDANCE_POLICY_STATS'
export const ATTENDANCE_POLICY_STATS_PENDING = 'ATTENDANCE_POLICY_STATS_PENDING'
export const ATTENDANCE_POLICY_STATS_FULFILLED = 'ATTENDANCE_POLICY_STATS_FULFILLED'
export const ATTENDANCE_POLICY_STATS_REJECTED = 'ATTENDANCE_POLICY_STATS_REJECTED'

export const ATTENDANCE_EMPLOYEE_POLICES = 'ATTENDANCE_EMPLOYEE_POLICES'
export const ATTENDANCE_EMPLOYEE_POLICES_PENDING = 'ATTENDANCE_EMPLOYEE_POLICES_PENDING'
export const ATTENDANCE_EMPLOYEE_POLICES_FULFILLED = 'ATTENDANCE_EMPLOYEE_POLICES_FULFILLED'
export const ATTENDANCE_EMPLOYEE_POLICES_REJECTED = 'ATTENDANCE_EMPLOYEE_POLICES_REJECTED'
